
import Vue from "vue";
import { Company } from "@/models/company";
import { Dossier } from "@/models/dossier";
import { CompanyService } from "@/services/company-service";
import { CompanyDossierService } from "@/services/company-dossier-service";
import "codemirror/mode/javascript/javascript";
import { CalculatedField, CalculatedFieldReturnType, getAllCalculatedFieldReturnTypes } from "@/models/calculated-field";
import { CalculatedFieldTable, getAllCalculatedFieldTables } from "@/models/calculated-field-tables";
import { CalculatedFieldService } from "@/services/calculated-field-service";
import { ISelectItem } from "winfakt-vue-components";
import AppDossierCalculatedFieldsPreloadEditModal from "@/components/dossier/DossierCalculatedFieldsPreloadEditModal.vue";

export default Vue.extend({
	data(){
		return {
			company: new Company(),
			dossier: new Dossier(),
			field: new CalculatedField(),
			ready: false,
			propertiesModal: false,
			preloadEditorOpen: false,
		};
	},
	computed: {
		cmOptions():any{
			return {
				mode: "text/javascript"
			};
		},
		tableItems():ISelectItem<CalculatedFieldTable>[]{
			return getAllCalculatedFieldTables().map(c=>{
				return {
					text: c,
					value: c
				};
			});
		},
		returnTypeItems():ISelectItem<CalculatedFieldReturnType>[]{
			return getAllCalculatedFieldReturnTypes().map(c=>{
				return {
					text: c,
					value: c
				};
			});
		},
		saveInExtraFieldItems():ISelectItem<string>[]{
			let result:ISelectItem<string>[] = [
				{
					text: "Geen",
					value: ""
				}
			];

			let types = ["Num", "Text", "Bool", "Time"];
			for (let t of types) {
				for (let i = 1; i <= 20; i++ ){
					result.push({
						text: `${t}${i}`,
						value: `${t}${i}`,
					});
				}
			}

			return result;
		},
	},
	methods: {
		goToCalculatedFields(){
			this.$router.push(`/companies/${this.company.id}/dossier/${this.dossier.id}/edit`);
		},
		async save(){
			if (this.field.ID == 0){
				this.field = await CalculatedFieldService.createField(this.dossier.id, this.field);
			}else{
				this.field = await CalculatedFieldService.editField(this.dossier.id, this.field);
			}
			this.$wf.notify("Changes saved", "success", 3000, "check");
		},
		editProperties(){
			this.propertiesModal = true;
		},
	},
	async created(){
		let companyId = parseInt(this.$route.params.companyId);
		let dossierId = parseInt(this.$route.params.dossierId);
		this.company = await CompanyService.getCompany(companyId);
		this.dossier = await CompanyDossierService.getDossier(companyId, dossierId);
		let fieldId = parseInt(this.$route.params.fieldId || "0");
		if (fieldId != 0){
			this.field = await CalculatedFieldService.getField(this.dossier.id, fieldId);
		}
		this.ready = true;
	},
	components: {
		AppDossierCalculatedFieldsPreloadEditModal
	}
});
